import { renderCellGrayZeros } from 'app/common/templates-next/table-template'

import { Entity } from './types'
import styles from './render-table-cell.module.scss'

export type CategoryCell = {
  columnKey: Entity.Category
  value: string | null
  line2?: string
  complexName?: string
}

const isCategoryCell = (cellData: CommonCell): cellData is CategoryCell => {
  return cellData?.columnKey === Entity.Category
}

type CommonCell = {
  columnKey: string
  value: string | null
}

export const renderTableCell = (cellData?: CommonCell) => {
  if (cellData && isCategoryCell(cellData)) {
    if (cellData.line2) {
      return (
        <div>
          <div className={styles.line1}>{cellData.value}</div>
          <div className={styles.line2}>{cellData.line2}</div>
        </div>
      )
    }
    if (cellData.complexName) {
      return (
        <span>
          <span className={styles.complexName}>{cellData.complexName}</span>{' '}
          <span>{(cellData.value || '').replace(cellData.complexName, '').trim()}</span>
        </span>
      )
    }
  }
  return renderCellGrayZeros(cellData)
}
